import React from 'react'
import DefaultPicture from '../../img/commons/default_picture.png'

export default class ProfilePicture extends React.Component {
  getStyles () {
    var image = this.props.data ? this.props.data : DefaultPicture
    let styles = {
      img: {
        'background': 'url(' + image + ')'
      }
    }
    return Object.assign({}, styles.img)
  }
  render () {
    var image = this.props.data ? this.props.data : DefaultPicture
    return (
      <div className='upload-picture-container'>
        <div className='image-upload'>
          <label htmlFor='file-input'>
            <div id='photo' className='person-photo' style={this.getStyles()}> </div>
            <div className='upload-photo-text' onChange={this.props.image.bind()}>Subir foto &#43;</div>
          </label>
          <input id='file-input' type='file' onChange={this.props.image.bind(this)}/>
        </div>
      </div>
    )
  }
}

ProfilePicture.propTypes = {
  image: React.PropTypes.func,
  imageUpdate: React.PropTypes.func,
  data: React.PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/Commons/ProfilePicture.js